import { BaseStore } from 'stores/BaseStore';
import { TaxCreditsAPI } from './TaxCreditsAPI';

export class BaseTaxCreditsStore extends BaseStore {
  public api = new TaxCreditsAPI(this.rootStore);
}
